'use strict';

/**
 * Composes a full adapter definition from the mock API graph DTO + presentation.
 * Tests and showcase only — live `usePipelineStatus` uses the PortalApi snapshot graph.
 */

import { composePipelineStatusLiveGraph } from '../composePipelineStatusLiveGraph';
import { mockPipelineStatusGraphForPipeline, MOCK_PIPELINE_STATUS_GRAPH_CATALOG } from './pipelineStatusGraphCatalog.mock';

/** @param {unknown} pipeline */
export function composeMockPipelineStatusGraphForPipeline(pipeline) {
	return composePipelineStatusLiveGraph(mockPipelineStatusGraphForPipeline(pipeline));
}

export function composeMockPipelineStatusCatalog() {
	return MOCK_PIPELINE_STATUS_GRAPH_CATALOG.graphs.map((graph) => composePipelineStatusLiveGraph(graph));
}
